const getExt = (fileName: string): string => {
  const parts = fileName?.split('.');
  return parts && parts.length > 1 ? parts[parts.length - 1] : '';
};
export default getExt;